import { render, staticRenderFns } from "./DeleteGroupDialog.vue?vue&type=template&id=e55aed30&scoped=true"
import script from "./DeleteGroupDialog.vue?vue&type=script&lang=js"
export * from "./DeleteGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteGroupDialog.vue?vue&type=style&index=0&id=e55aed30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55aed30",
  null
  
)

export default component.exports